import React from 'react'
import {
  PRODOTTI,
  PAGINEDETAIL,
} from '../../utils/endpoint'

import ProdottoTemplate from '../../components/template/ProdottoTemplate/ProdottoTemplate'
import { api } from '../../utils'
import * as Sentry from '@sentry/browser'

const SchedaProdotto = ({ data, slug, prodotto_articolo, page, statusCode }) => {
  if (!page) return <Error statusCode={statusCode} />

  return <ProdottoTemplate
    page={page}
    data={data}
    slug={slug}
    prodotto_articolo={prodotto_articolo}
  />
}

export async function getServerSideProps({ res, query: { slug }, locale }) {
  try {
    const response = await api.get(`${PRODOTTI}${slug[0]}/`, { params: { lang: locale } })
    const product = await response.data

    res.setHeader('Cache-Control', 's-maxage=43200, stale-while-revalidate')

    const redirect = product?.redirect
    if (redirect) {
      res.setHeader('location', redirect)
      res.statusCode = 301
      res.end()
      return { props: {} }
    }

    const slug_articolo = slug.length > 1 ? slug[1] : null
    let prodotto_articolo = product.articoli.find((item) => item.slug == slug_articolo, null)

    if (!prodotto_articolo) {
      prodotto_articolo = product.articoli[0]
    }

    const pageResponse = await api
      .get(PAGINEDETAIL, {
        params: {
          chiave: 'articolo-detail',
          lang: locale,
          content_type_id: prodotto_articolo?.model,
          object_id: prodotto_articolo?.id,
        },
      })
      .catch((err) => {
        Sentry.captureException(err)
      })

    const page = pageResponse?.data ? pageResponse?.data : null

    return {
      props: {
        page,
        data: product,
        slug: slug_articolo,
        prodotto_articolo: prodotto_articolo ? prodotto_articolo : null,
      },
    }
  } catch (error) {
    res.statusCode = 404
    return { props: { statusCode: 404 } }
  }
}

export default SchedaProdotto
